import { format } from 'date-fns'
import { getLocal } from './Utils/Profile'

const init = async () => {
    console.log('Clevertap was initialized')
}

const getDataStructure = () => {
    const currentUser = localStorage.getItem('currentUser')

    const user = currentUser && JSON.parse(currentUser)
    if (!user) {
        return {}
    }
    const local = getLocal()
    const commerceId = user?.sEstablecimiento + local

    return {
        'Región (DB Comercio - sRegion)': user.cLocal[0].sRegion,
        'Comuna (DB Comercio - sComuna)': user.cLocal[0].sComuna,
        'Código de comercio': user.sEstablecimiento,
        'Código de local': local,
        Fecha: format(new Date(), 'yyyy/MM/dd'),
        Hora: format(new Date(), 'kk:mm:ss'),
        'ID o Cookie de usuario': commerceId,
        mail: user.sEmailContacto,
    }
}

const logIn = (payload = {}) => {
    window.clevertap.onUserLogin.push(payload)
    window.clevertap.profile.push(payload)
}

const track = (name, payload) => {
    const tmpPayload = {
        ...getDataStructure(),
        ...payload,
        pageURL: window.location.href,
    }

    window.clevertap.event.push(name, tmpPayload)
}

export { init, logIn, track }
